import { useState } from 'react';
import { useReduxState } from 'hooks';
import { Button } from 'components/common';
import { ReaderBlockDiscussionCommentForm } from '.';

import type { ButtonSize } from 'components/common/Button';
import type { CommonBlockPropsReader } from 'components/reader/blocks';
import type { DiscussionSubmitObj } from './ReaderBlockDiscussion';

interface Props extends Pick<CommonBlockPropsReader<'discussion'>, 'fontSize'> {
  allowAnonymousComments: boolean;
  isChildForm?: boolean;
  onSubmit: (args: DiscussionSubmitObj) => Promise<void>;
  parentCommentId?: number;
}

const ReaderBlockDiscussionCommentAdd = ({
  allowAnonymousComments,
  isChildForm,
  fontSize,
  onSubmit,
  parentCommentId
}: Props) => {
  const {
    messages,
    pageState: { offline }
  } = useReduxState();

  const [isOpen, setIsOpen] = useState(false);

  const handleCancel = () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);

  return (
    <div className="comment-add" style={isOpen ? { flexBasis: '100%' } : {}}>
      {isOpen ? (
        <div className="form">
          <ReaderBlockDiscussionCommentForm
            allowAnonymousComments={allowAnonymousComments}
            isChildForm={isChildForm}
            fontSize={fontSize}
            onCancel={handleCancel}
            onSubmit={onSubmit}
            parentCommentId={parentCommentId}
          />
        </div>
      ) : (
        <div className="controls">
          <Button
            category={isChildForm ? 'lighter' : 'light'}
            disabled={offline}
            {...(offline
              ? {
                  'aria-label': messages.readerDiscussionOffline,
                  'data-tooltip': messages.readerDiscussionOffline
                }
              : {})}
            onClick={handleOpen}
            text={
              isChildForm ? messages.commonReply : messages.commonAddComment
            }
            size={
              (isChildForm
                ? {
                    small: 'small',
                    medium: 'small',
                    large: 'medium',
                    huge: 'medium'
                  }[fontSize]
                : {
                    small: 'medium',
                    medium: 'medium',
                    large: 'large',
                    huge: 'large'
                  }[fontSize]) as ButtonSize
            }
          />
        </div>
      )}

      <style jsx>{`
        .comment-add {
          margin-top: ${isChildForm ? '15px' : '0'};
        }
        .controls {
          text-align: right;
        }
      `}</style>
    </div>
  );
};

export default ReaderBlockDiscussionCommentAdd;
